import axios from 'axios';

import { API } from '@/config/constants';


export const getIntegrations = async (config) => {
  const response = await axios.get(`${API}/integrations`, ...(config ? [config] : []));
  return response.data;
};

export const connectIntegration = async (integration, key, config) => {
  const response = await axios.post(`${API}/integrations/connect`, { integration, key }, ...(config ? [config] : []));
  return response.data;
};

export const setStripeWebhookSecret = async (key, config) => {
  const response = await axios.post(`${API}/integrations/stripe/webhook-secret`, {
    integration: 'stripe',
    key,
  }, ...(config ? [config] : []));
  return response.data;
};

export const disconnectIntegration = async (integration, config) => {
  const response = await axios.delete(`${API}/integrations/${integration}`, ...(config ? [config] : []));
  return response.data;
};

export const getStripeSendingFlorist = async (config) => {
  const response = await axios.get(`${API}/integrations/stripe/sending-florist`, ...(config ? [config] : []));
  return response.data;
};

export const setStripeSendingFlorist = async (sendingFloristId, config) => {
  const response = await axios.put(`${API}/integrations/stripe/sending-florist`, {
    sending_florist_id: sendingFloristId || null,
  }, ...(config ? [config] : []));
  return response.data;
};
